/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthBaseService } from '../auth-base-service';
import { AuthApiConfiguration } from '../auth-api-configuration';
import { AuthStrictHttpResponse } from '../auth-strict-http-response';

import { organizationFhirIdUsersGet } from '../fn/organization/organization-fhir-id-users-get';
import { OrganizationFhirIdUsersGet$Params } from '../fn/organization/organization-fhir-id-users-get';
import { OrganizationUserModel } from '../models/organization-user-model';

@Injectable({ providedIn: 'root' })
export class AuthOrganizationService extends AuthBaseService {
  constructor(config: AuthApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `organizationFhirIdUsersGet()` */
  static readonly OrganizationFhirIdUsersGetPath = '/Organization/{fhirId}/Users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationFhirIdUsersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationFhirIdUsersGet$Response(params: OrganizationFhirIdUsersGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<Array<OrganizationUserModel>>> {
    return organizationFhirIdUsersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationFhirIdUsersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationFhirIdUsersGet(params: OrganizationFhirIdUsersGet$Params, context?: HttpContext): Observable<Array<OrganizationUserModel>> {
    return this.organizationFhirIdUsersGet$Response(params, context).pipe(
      map((r: AuthStrictHttpResponse<Array<OrganizationUserModel>>): Array<OrganizationUserModel> => r.body)
    );
  }

}
